import React,{useEffect} from 'react';
import * as S from './BoardingDroping.styles';
import LocationBox from '../LocationPoints/LocationPoints';
import Loader from './../../SrpLoader/Loader/Loader';
import ContentUnavailable from './../../SrpErrorStates/ContentUnavailable';
import {SEAT_LAYOUT} from './../../../../../config/messages'
import dateFormat from 'dateformat';
import getDateObj from './../../../../../utils/GetDateObj'
import {scrollEletoView} from './../../../../../containers/Common/Utils';

const BoardingDroping = (props) => {
  const{data,error,isLoading,routeId} = props;
  useEffect(() => {
    const idOfElToScrollTo = `#boardingDropping${routeId.replace('@', '')}`;
    scrollEletoView(idOfElToScrollTo, {
      behavior: 'smooth',
    });

  }, [])
 
  if( error ){
    return  (
      <S.ContentWrap id={`boardingDropping${routeId.replace('@', '')}`}>
      <ContentUnavailable text={SEAT_LAYOUT.BP_DP_NOT_AVAILABLE} />
     </S.ContentWrap>
  
    )
  }
  if(isLoading){
    return (
      <S.ContentWrap id={`boardingDropping${routeId.replace('@', '')}`}>
        <Loader></Loader>
       </S.ContentWrap>
    )
  }
  const {bp,dp,restStops} = data;
  if( !bp && !dp && !restStops ){
    return  (
      <S.ContentWrap id={`boardingDropping${routeId.replace('@', '')}`}>
      <ContentUnavailable text={SEAT_LAYOUT.BP_DP_NOT_AVAILABLE} />
     </S.ContentWrap>
  
    )
  }
       
  return(
  <S.ContentWrap id={`boardingDropping${routeId.replace('@', '')}`}>
   {bp && bp.length ? <div>
      <S.Header>Boarding Points</S.Header>
      <S.WrapperBox>
        { bp.map((bp)=>{
          return  (<LocationBox key={bp.BPName+bp.BPAddress}
          isSelection={false}
          time={dateFormat(getDateObj(bp.BPTime.substring(0,bp.BPTime.length-1)), 'HH:MM')}
          location={bp.BPLocation}
          address={bp.BPAddress}
        />);
       
        })}
      </S.WrapperBox>
    </div> : null}
   {dp && dp.length ? <div>
      <S.Header>Dropping Points</S.Header>
      <S.WrapperBox>
      {dp && dp.map((dp)=>{
          return  (<LocationBox key={dp.DPName+dp.DPAddress}
          isSelection={false}
          time={dateFormat(getDateObj(dp.DPTime.substring(0,dp.DPTime.length-1)), 'HH:MM')}
          location={dp.DPLocation}
          address={dp.DPAddress}
        />);
       
        })}
    
      </S.WrapperBox>
    </div> :null}
  {restStops && restStops.length ?  <S.RestStopsWrap>
      <S.Header>Rest Stops</S.Header>
        {
          restStops && restStops.map((item)=>{
            return (  
              <S.RestStopsBox key={item.t+item.at}>
   
              <LocationBox
              isSelection={false}
              time={function(){
                const arr = item.at && item.at.length ? item.at.split(':') : [];
                return ( arr && arr.length ? `${arr[0]}:${arr[1]}` : '')
             
              }()}
              location={item.t}
              address={item.address || ''}
              subText={item.st || ''}
            />
              </S.RestStopsBox>
    
        )
          })
        }
    </S.RestStopsWrap> :null}
  </S.ContentWrap>
);
}
export default BoardingDroping;
